export enum PaymentMethodEnum {
  DirectDebit = "Direct Debit",
  OnlineBanking = "Online Banking",
}
